/* eslint-disable */
import { api } from './../../api.js';
import {vue_instance} from "../../main";
//import api_routes from './../../api_routes.js';

const state = {
};

const getters = {

}

const mutations = {
}

const actions = {
    updateUserNotifications : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.patch('admins/' + data.id + '/notificaciones', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    checkEmailAdmin : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.post('admins/checkemail', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    createAdmin : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.post('admins', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    updateAdmin : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.patch('admins/' + data.id, data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    deleteAdmin : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.delete('admins/' + data.id, {}).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    getAdmins : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.get('admins', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    getAdmin : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.get('admins/' + data.id, {}).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    unblockUser : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.post('admins/' + data.id + '/unblock', {}).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    }
}

export default {
    state,
    actions,
    getters,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/AdminsModule.js